/* eslint-disable max-len, @typescript-eslint/indent */
/* eslint-disable @typescript-eslint/restrict-template-expressions */
import {
  Alert,
  Button,
  Card,
  Checkbox,
  Col,
  Form,
  Input,
  message,
  Modal,
  Row,
  Space,
  Spin
} from 'antd'
import moment from 'moment/moment'
import React, { useEffect, useState } from 'react'
import { useParams } from 'react-router-dom'
import '../../asserts/css/custom.css'
import minijust_logo from '../../assets/img/minijust_logo.png'
import { PHONE_PATTERN } from '../../constants/general'
import InstitutionUserService from '../../services/InstitutionUserService'
import { v4 as uuidv4 } from 'uuid'

interface RefundRequestValues {
  transaction_reference: string
  bank_code: string
  beneficiary_bank_account_name: string
  beneficiary_bank_name: string
  beneficiary_account_number: string
  refundable_bid_security_amount: string
  transaction_currency: string
  amount: string
  bidder_national_id_number: string
  phone_number: string
  execution_case_number: string
  property_id: string
  bidder_id: string
  bid_security_id: string
  email: string
}

const MakeRefundRequest: React.FC = () => {
  const userInfo = JSON.parse(localStorage.getItem('userInfo') ?? '{}')
  const [form] = Form.useForm()
  const [showForm, setShowForm] = useState(false)
  const [fullName, setBidderFullName] = useState('')
  const [phone_number, setPhoneNumber] = useState('')
  const [payment_date, setPaymentDate] = useState('')
  const [token, setToken] = useState(userInfo.token ?? '')
  const [isEdit, setIsEdit] = useState(false)
  const { ref_number } = useParams<{ ref_number?: string }>()
  const [loading, setLoading] = useState(false)
  const [declarationChecked, setDeclarationChecked] = useState(false)
  const [loadingRefund, setLoadingRefund] = useState(false)
  const [showOTPForm, setShowOTPForm] = useState(false)
  const [countdown, setCountdown] = useState(300000)
  const [isFormValidated, setIsFormValidated] = useState(true)
  const [isFormSubmitted, setIsFormSubmitted] = useState(false)
  const [transactionReference, setTransactionReference] = useState<string>('')
  const [otpValue, setOtpValue] = useState('')
  const [otpDigits, setOtpDigits] = useState<string[]>(['', '', '', '', '', ''])
  const [otpError, setOtpError] = useState('')
  const [showBankTransferChargeModal, setShowBankTransferChargeModal] = useState(false)
  const [paymentAmount, setPaymentAmount] = useState('')
  const [refundableAmount, setRefundableAmount] = useState('0')
  const [fetchedBankCode, setBankCode] = useState('')
  const [showWarningAlert, setShowWarningAlert] = useState(false)
  const [showWarningAlert2, setShowWarningAlert2] = useState(false)
  const [showSuccessAlert, setShowSuccessAlert] = useState(false)
  const [showCancelMessage, setShowCancelMessage] = useState(false)
  const [targetPaymentDateValue, setTargetPaymentDateValue] = useState(false)
  const [showBankCodeModal, setShowBankCodeModal] = useState(false)
  const [showHello, setShowHello] = useState(false)
  const [showInvalidReferenceNumberModal, setShowInvalidReferenceNumberModal] = useState(false)
  const [showValidationErrorModal, setShowValidationErrorModal] = useState(false)
  const [validationErrorMessage, setValidationErrorMessage] = useState('')
  const [isVisible, setIsVisible] = useState(true)
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  const handleAgree = () => {
    setShowBankTransferChargeModal(false)
    setShowForm(true)
  }
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setOtpValue(e.target.value)
  }

  // OTP input handlers for better UX
  const handleOtpChange = (index: number, value: string): void => {
    if (!/^[0-9]?$/.test(value)) { return }
    const next = [...otpDigits]
    next[index] = value
    setOtpDigits(next)
    setOtpValue(next.join(''))
    setOtpError('')
    const nextInput = document.getElementById(`otp-input-${index + 1}`) as HTMLInputElement | null
    if (value !== '' && nextInput !== null) { nextInput.focus() }
  }

  const handleOtpKeyDown = (index: number, e: React.KeyboardEvent<HTMLInputElement>): void => {
    if (e.key === 'Backspace' && otpDigits[index] === '') {
      const prevInput = document.getElementById(`otp-input-${index - 1}`) as HTMLInputElement | null
      if (prevInput !== null) { prevInput.focus() }
    }
  }

  const handleOtpPaste = (e: React.ClipboardEvent<HTMLInputElement>): void => {
    e.preventDefault()
    const text = e.clipboardData.getData('text').replace(/\D/g, '').slice(0, 6)
    if (text.length === 0) { return }
    const filled = Array.from({ length: 6 }, (_, i) => text[i] ?? '')
    setOtpDigits(filled)
    setOtpValue(filled.join(''))
    setOtpError('')
    const lastIndex = Math.min(text.length, 6) - 1
    const nextInput = document.getElementById(`otp-input-${lastIndex}`) as HTMLInputElement | null
    if (nextInput !== null) { nextInput.focus() }
  }

  // Handle Resend OTP
  const handleResendOTP = async (): Promise<void> => {
    try {
      // Validate transaction reference exists
      if (transactionReference === '' || transactionReference == null) {
        void message.error('Transaction reference is required. Please refresh the page and try again.')
        return
      }

      setOtpError('')
      setOtpDigits(['', '', '', '', '', ''])
      setOtpValue('')
      setCountdown(300000)

      const payloadOTPForRefund = {
        transaction_reference: transactionReference,
        status: 'PENDING'
      }

      // eslint-disable-next-line no-console
      console.log('Resending OTP with payload:', payloadOTPForRefund)

      const otpResponse = await InstitutionUserService.createOtpCode(payloadOTPForRefund)

      // eslint-disable-next-line no-console
      console.log('Resend OTP Response:', otpResponse)

      // Check for success - responseBody returns response.data
      const messageStr = (otpResponse?.message != null && typeof otpResponse.message === 'string') ? otpResponse.message : ''
      const hasValidMessage = messageStr !== '' && messageStr.toLowerCase().includes('error') === false
      const isResendSuccess = otpResponse?.status === 200 ||
                             otpResponse?.status === 201 ||
                             otpResponse?.code === 200 ||
                             otpResponse?.code === 201 ||
                             hasValidMessage

      if (isResendSuccess) {
        void message.success('OTP has been resent to your phone number.')
        const firstInput = document.getElementById('otp-input-0') as HTMLInputElement | null
        if (firstInput !== null) {
          firstInput.focus()
        }
      } else {
        const responseMessage = otpResponse?.message ?? otpResponse?.data?.message ?? 'Failed to resend OTP. Please try again.'
        void message.error(responseMessage)
      }
    } catch (error: any) {
      // eslint-disable-next-line no-console
      console.error('Resend OTP Error:', error)

      if (error?.response != null) {
        const status = error.response.status
        const errorData = error.response.data
        const errorMessage = errorData?.message ?? errorData?.error ?? `Failed to resend OTP. ${status !== undefined ? `(Status: ${status})` : ''}`
        void message.error(errorMessage)
      } else if (error?.request != null) {
        void message.error('Network error: Unable to connect to the server. Please check your internet connection and try again.')
      } else {
        const errorMessage = error?.message ?? 'Failed to resend OTP. Please try again.'
        void message.error(errorMessage)
      }
    }
  }

  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  const handleOTPFormCancel = () => {
    setShowOTPForm(false)
    setOtpDigits(['', '', '', '', '', ''])
    setOtpValue('')
    setOtpError('')
  }
  useEffect(() => {
    const timer = setTimeout(() => {
      setIsVisible(false)
    }, 3000)
    return () => {
      clearTimeout(timer)
    }
  }, [])

  useEffect(() => {
    const timer = setTimeout(() => {
      setShowHello(true)
    }, 3000)
    return () => {
      clearTimeout(timer)
    }
  }, [])

  const handleOTPSubmit = async (): Promise<void> => {
    const otp = (otpDigits.join('') !== '' ? otpDigits.join('') : otpValue)
    if (otp.length !== 6) {
      setOtpError('Please enter the complete 6-digit OTP code')
      return
    }

    setOtpError('')
    setLoadingRefund(true)
    try {
      const respo: any = await InstitutionUserService.verifyOtpForRequestedRefund({
        transaction_reference: transactionReference,
        otp
      })

      if (respo?.status === 200) {
        setShowOTPForm(false)
        setShowSuccessAlert(true)
        setIsFormValidated(true)
        form.resetFields()
        return
      }

      setOtpError('Invalid OTP code. Please try again.')
      void message.warning('Failed To Verify OTP')
    } catch (error: any) {
      if (error?.response?.status === 400) {
        setOtpError(error?.response?.data?.message ?? 'Invalid OTP code. Please try again.')
        setOtpDigits(['', '', '', '', '', ''])
        setOtpValue('')
        const firstInput = document.getElementById('otp-input-0') as HTMLInputElement | null
        if (firstInput !== null) {
          firstInput.focus()
        }
      } else {
        setOtpError('An error occurred. Please try again.')
      }
    } finally {
      setLoadingRefund(false)
    }
  }

  useEffect(() => {
    const timer = setInterval(() => {
      setCountdown((prevCountdown) => {
        if (prevCountdown === 0) {
          clearInterval(timer)
          return 0
        }
        return prevCountdown - 1000
      })
    }, 1000)

    return () => {
      clearInterval(timer)
    }
  }, [])

  useEffect(() => {
    // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
    const fetchData = async () => {
      setLoading(true)
      if (ref_number != null) {
        try {
          const res = await InstitutionUserService.validateBidderForRefund(ref_number)

          // eslint-disable-next-line @typescript-eslint/strict-boolean-expressions
          if (res && res.status === 200) {
            const data = res.data

            form.setFieldsValue({
              bidder_full_name: `${data?.bidder?.firstName} ${data?.bidder?.lastName}`,
              bidder_national_id_number: data?.bid?.identityNumber,
              phone_number: data?.bid?.phoneNumber,
              property_id: data?.bid?.propertyId,
              transaction_reference: data?.bid?.bidSecurityRefNumber,
              execution_case_number: data?.bid?.executionCaseNumber,
              beneficiary_account_number: data?.bid?.bankAccountNumber,
              beneficiary_bank_name: data?.bid?.bankName,
              beneficiary_account_name: data?.bid?.bankAccountName,
              // beneficiary_account_name: `${data?.bidder?.firstName} ${data?.bidder?.lastName}`,
              beneficiary_bank_account_name: data?.bid?.bankAccountName,
              bank_code: data?.bid?.bankCode
            })

            // Set states using extracted data
            setBankCode(data?.bid?.bankCode)
            setTransactionReference(data?.bid?.bidSecurityRefNumber)
            setBidderFullName(data?.bid?.bankAccountName)

            // Load additional details using the extracted transaction reference
            // eslint-disable-next-line @typescript-eslint/no-shadow
            const transactionReference = data?.bid?.bidSecurityRefNumber
            if (transactionReference !== null) {
              const detailsRes = await InstitutionUserService.loadBidsDetailsForRefund(
                transactionReference
              )
              // eslint-disable-next-line @typescript-eslint/strict-boolean-expressions
              if (detailsRes && detailsRes.status === 200) {
                const paymentData = detailsRes.data
                let amountValue = parseInt(String(paymentData?.payment.amount)).toLocaleString()
                // Only subtract 1000 if bankCode is NOT '040' or '40'
                if (fetchedBankCode !== '040' && fetchedBankCode !== '40') {
                  amountValue = (
                    parseInt(String(paymentData?.payment.amount)) - 1000
                  ).toLocaleString()
                }
                form.setFieldsValue({
                  bidder_id: paymentData?.bid?.bidder.bidder_id,
                  bid_security_id: paymentData?.payment.bid_security_id,
                  payment_date: paymentData?.payment?.payment_date,
                  amount: paymentData?.payment?.amount,
                  transaction_currency: paymentData.payment.currency,
                  refundable_bid_security_amount: amountValue,
                  email: paymentData?.bid?.bidder?.email
                })
                setPaymentDate(paymentData?.payment.payment_date)
                setPaymentAmount(paymentData?.payment.amount)
              }
            }
          } else {
            // eslint-disable-next-line no-console
            console.error('Error: Invalid response from server')
          }
        } catch (error) {
          // eslint-disable-next-line no-console
          console.error('Error fetching data:', error)
        } finally {
          setLoading(false)
        }
      } else {
        setLoading(false)
      }
    }

    void fetchData()
  }, [ref_number, form, fetchedBankCode])

  useEffect(() => {
    const bankCode = form.getFieldValue('bank_code')
    setBankCode(bankCode)
    // eslint-disable-next-line no-console
    // Only subtract 1000 if bankCode is NOT '040' or '40'
    if (bankCode !== '040' && bankCode !== '40') {
      if (bankCode !== null && bankCode !== undefined && bankCode !== '') {
        setShowBankTransferChargeModal(true)
        setShowBankCodeModal(false)
        setShowCancelMessage(false)
        const bailiffRefundableAmount = Number(paymentAmount) - 1000
        setRefundableAmount(bailiffRefundableAmount.toString())
      } else {
        setShowBankTransferChargeModal(false)
        setShowBankCodeModal(true)
      }
    } else {
      if (bankCode !== null && bankCode !== undefined && bankCode !== '') {
        setShowBankTransferChargeModal(true)
        setShowBankCodeModal(false)
        setShowCancelMessage(false)
        setRefundableAmount(paymentAmount)
      } else {
        setShowBankTransferChargeModal(false)
        setShowBankCodeModal(true)
      }
    }
  }, [form, paymentAmount])

  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  const onFinish = async (values: any): Promise<void> => {
    try {
      setLoadingRefund(true)
      setIsFormSubmitted(true)

      // Validate payment date
      const paymentDate = moment(values.payment_date, 'YYYY-MM-DD HH:mm:ss')
      const targetPaymentDate = moment('2024-07-25', 'YYYY-MM-DD')

      if (!paymentDate.isSameOrAfter(targetPaymentDate)) {
        setShowWarningAlert2(true)
        setLoadingRefund(false)
        return
      }

      // Validate declaration
      if (!declarationChecked) {
        void message.warning('Please confirm the declaration part to be able to submit your Request.')
        setLoadingRefund(false)
        return
      }

      // Validate transaction reference exists and update state if needed
      if (values.transaction_reference === '' || values.transaction_reference == null) {
        void message.error('Transaction reference is required. Please refresh the page and try again.')
        setLoadingRefund(false)
        return
      }

      // Ensure transactionReference state is set from form values
      if (transactionReference === '' || transactionReference == null) {
        setTransactionReference(values.transaction_reference)
        // eslint-disable-next-line no-console
        console.log('Setting transactionReference from form values:', values.transaction_reference)
      }

      const txRef = transactionReference !== '' && transactionReference != null
        ? transactionReference
        : values.transaction_reference

      if (txRef === '' || txRef == null) {
        setLoadingRefund(false)
        void message.error('Transaction reference is required. Please refresh the page and try again.')
        return
      }

      setTransactionReference(txRef)

      // Use status-aware endpoint for pending check.
      try {
        const existingPendingResponse: any = await InstitutionUserService.loadRefundRequestId({
          transaction_reference: txRef,
          status: 'PENDING'
        })
        if (existingPendingResponse?.status === 200) {
          void message.info('A pending request exists and will be replaced with a new one.')
        }
      } catch (error: any) {
        // 404 means no pending record; proceed with create.
        if (error?.response?.status !== 404) {
          void message.error('Failed to validate pending request. Please try again.')
        }
      }

      // Create request (backend generates OTP); then open OTP modal.
      const isCreated = await createNewRefundRequest({ ...values, transaction_reference: txRef })
      if (!isCreated) {
        setLoadingRefund(false)
        return
      }

      setLoadingRefund(false)
      setOtpDigits(['', '', '', '', '', ''])
      setOtpValue('')
      setOtpError('')
      setShowOTPForm(true)
      setIsFormValidated(true)
      setCountdown(300000)
      void message.success('OTP has been sent to your phone number. Please check your SMS.')

      setTimeout(() => {
        const firstInput = document.getElementById('otp-input-0') as HTMLInputElement | null
        if (firstInput !== null) {
          firstInput.focus()
        }
      }, 100)
    } catch (err: any) {
      setLoadingRefund(false)
      // eslint-disable-next-line no-console
      console.error('Error in onFinish:', err)
    }
  }
// Helper function to handle new refund requests
  const handleNewRefundRequest = async (values: RefundRequestValues): Promise<void> => {
    try {
      const response = await InstitutionUserService.loadRefundRequestId({
        transaction_reference: values.transaction_reference,
        status: 'PENDING'
      })
      // Check if a refund request already exists
      if (response?.status === 200) {
        setLoadingRefund(false)
        await InstitutionUserService.validateRequestWhenOtpExpired({
          transaction_reference: values.transaction_reference,
          status: 'PENDING'
        })
        // void message.info(`Refund request already exists for this transaction reference: ${values.transaction_reference}`)
        await createNewRefundRequest(values)
      }

      if ((Boolean((response?.status))) && response.status !== 404) {
        // Handle unexpected status codes
        throw new Error(`Unexpected response status: ${response.status}`)
      }
    } catch (error) {
      setLoadingRefund(false)
      // eslint-disable-next-line no-console
      console.log('Error checking refund request status')
      await createNewRefundRequest(values)
      // eslint-disable-next-line no-console
      console.error('Error:', error)
    }
  }
  // Helper function for creating new refund request
  const createNewRefundRequest = async (values: any): Promise<boolean> => {
    // eslint-disable-next-line no-console
    console.log('=== createNewRefundRequest STARTED ===')
    // eslint-disable-next-line no-console
    console.log('Form values received:', values)
    try {
      // eslint-disable-next-line no-console
      console.log('Creating refund request payload...')

      const txRef = (values.transaction_reference ?? transactionReference) as string
      let verifiedBidderId = values.bidder_id
      let verifiedBidSecurityId = values.bid_security_id

      if (txRef === '' || txRef == null) {
        void message.error('Transaction reference is required. Please refresh the page and try again.')
        setLoadingRefund(false)
        return false
      }

      // Always reload IDs from source-of-truth API before submit to avoid stale/mismatched pair.
      try {
        const detailsRes = await InstitutionUserService.loadBidsDetailsForRefund(txRef)
        const latestBidderId = detailsRes?.data?.bid?.bidder?.bidder_id
        const latestBidSecurityId = detailsRes?.data?.payment?.bid_security_id

        if (latestBidderId == null || latestBidSecurityId == null) {
          void message.error('Unable to validate bidder details for this transaction reference.')
          setLoadingRefund(false)
          return false
        }

        verifiedBidderId = latestBidderId
        verifiedBidSecurityId = latestBidSecurityId
        form.setFieldsValue({
          bidder_id: latestBidderId,
          bid_security_id: latestBidSecurityId
        })
      } catch (verificationError) {
        // eslint-disable-next-line no-console
        console.error('Failed to verify bidder and bid security IDs:', verificationError)
        void message.error('Failed to validate bidder details. Please try again.')
        setLoadingRefund(false)
        return false
      }

        // Prepare refund request payload
        const payload = {
          RefundRequest: {
            bank_code: values.bank_code,
            transaction_reference: txRef,
            debit_account_number: '000400696575429',
            debit_account_name: 'MINIJUST AUCTION FUNDS MAF',
            beneficiary_account_name: values.beneficiary_bank_account_name,
            beneficiary_bank_name: values.beneficiary_bank_name,
            beneficiary_account_number: values.beneficiary_account_number,
            amount: parseInt(values.refundable_bid_security_amount.replace(/,/g, '')),
            transaction_currency: values.transaction_currency,
            reason: `Refund of ${values.amount} for ${values.beneficiary_bank_account_name} ${values.bidder_national_id_number}, ${values.phone_number} ${values.execution_case_number} with ${values.property_id}`,
            status: 'PENDING',
            bidder_id: verifiedBidderId,
            bid_security_id: verifiedBidSecurityId,
            phone_number: values.phone_number,
            email: values.email,
            created_by: fullName
          }
        }

        // eslint-disable-next-line no-console
        console.log('=== PAYLOAD PREPARED ===')
        // eslint-disable-next-line no-console
        console.log('Triggering refund request with payload:', JSON.stringify(payload, null, 2))
        try {
          // eslint-disable-next-line no-console
          console.log('=== ABOUT TO CALL TriggerRefundRequest ===')
          // eslint-disable-next-line no-console
          console.log('Service method exists:', typeof InstitutionUserService.TriggerRefundRequest)
          const refundResponse = await InstitutionUserService.TriggerRefundRequest(payload, '')
          // eslint-disable-next-line no-console
          console.log('=== TriggerRefundRequest CALLED SUCCESSFULLY ===')

          // eslint-disable-next-line no-console
          console.log('Refund Response:', refundResponse)

          // Check for success - responseBody returns response.data, so check for status/code in data
          const isRefundSuccess = refundResponse?.status === 201

          if (isRefundSuccess) {
            // eslint-disable-next-line no-console
            console.log('Refund request created successfully!')
          // Get refund request ID
          const param = { transaction_reference: txRef }
          const getLastRefundReferenceNumber = await InstitutionUserService.getRefundRequestId(param)
          const refundRequestId = getLastRefundReferenceNumber?.data?.refund_request_id

          // Create audit log
          const generatedUuid = uuidv4()
          const auditPayload = {
            AuditLogsData: {
              action: 'INSERT',
              table_name: 'refund_request',
              record_id: generatedUuid,
              old_data: {},
              new_data: payload.RefundRequest,
              created_by: fullName,
              refund_request_id: refundRequestId
            }
          }

          await InstitutionUserService.TrackRecords(auditPayload)

            // Record created successfully with status 'PENDING'
            // OTP generation and modal opening are handled in onFinish
            // This function only creates the refund request record
            // eslint-disable-next-line no-console
            console.log('Refund request created successfully with status PENDING.')
            return true
          } else {
            setLoadingRefund(false)
            const errorMsg = refundResponse?.message ?? refundResponse?.error ?? 'Failed to create refund request. Please try again.'
            void message.error(errorMsg)
            // eslint-disable-next-line no-console
            console.error('Refund request failed:', refundResponse)
            return false
          }
        } catch (refundError: any) {
          setLoadingRefund(false)
          // eslint-disable-next-line no-console
          console.error('Error calling TriggerRefundRequest:', refundError)

          if (refundError?.response != null) {
            const status = refundError.response.status
            const errorData = refundError.response.data
            const errorMessage = errorData?.message ?? errorData?.error ?? `Failed to create refund request. ${status !== undefined ? `(Status: ${status})` : ''}`
            void message.error(errorMessage)
          } else if (refundError?.request != null) {
            void message.error('Network error: Unable to connect to the server. Please check your internet connection and try again.')
          } else {
            const errorMessage = refundError?.message ?? 'An error occurred while creating the refund request'
            void message.error(errorMessage)
          }
          return false
        }
    } catch (error: any) {
      setLoadingRefund(false)
      setShowWarningAlert(true)

      // eslint-disable-next-line no-console
      console.error('=== ERROR in createNewRefundRequest ===')
      // eslint-disable-next-line no-console
      console.error('Error type:', error?.constructor?.name)
      // eslint-disable-next-line no-console
      console.error('Error message:', error?.message)
      // eslint-disable-next-line no-console
      console.error('Full error:', error)

      if (error?.response != null) {
        const status = error.response.status
        const errorData = error.response.data
        const errorMessage = errorData?.message ?? errorData?.error ?? `Failed to process refund request. ${status !== undefined ? `(Status: ${status})` : ''}`
        void message.error(errorMessage)
      } else if (error?.request != null) {
        void message.error('Network error: Unable to connect to the server. Please check your internet connection and try again.')
      } else {
        const errorMessage = error?.message ?? 'An error occurred while processing the refund request'
        void message.error(errorMessage)
      }
      return false
    }
  }
  return (
    <div className="w-full">
      <div className="navbar pay-bot-border navbar-background">
        <div className="flex">
          <div className="nav-logo">
            <img src={minijust_logo} alt="Logo" />
          </div>
          <div className="nav-content text-standard md:text-title">
            <div className="nav-content-header">MINIJUST - IECMS</div>
            <div>Bid Security Online Payment and Refund</div>
          </div>
        </div>
      </div>

      <div className="scrollableContent">
        {showForm && fetchedBankCode !== null && (
          <Form
            name="normal_login"
            layout="vertical"
            className="login-form p-10"
            initialValues={{ remember: true }}
            autoComplete="off"
            /* eslint-disable-next-line @typescript-eslint/no-misused-promises */
            onFinish={onFinish}
            form={form}
          >
            <Space direction="vertical" size={5} className=" w-full content-background">
              <Card className="card-border h-full ">
                <div
                  className="font-extrabold text-title flex text-center
            items-center justify-center leading-10 text-gray-500 pb-2"
                >
                  Please fill the form below for requesting refund
                </div>

                <div
                  className="green-color font-extrabold text-title flex text-center
            items-center justify-center py-5"
                >
                  Refund Request Details
                </div>
                <Row gutter={[16, 16]}>
                  <Col xs={24} md={4} xl={4}></Col>
                  <Col xs={24} md={8} xl={8}>
                    <Form.Item
                      label="Bidder's National ID Number"
                      name="bidder_national_id_number"
                      rules={[
                        {
                          required: true,
                          message: "Please enter Bidder's National ID Number"
                        }
                      ]}
                    >
                      <Input
                        maxLength={16}
                        placeholder="Enter Bidder's National ID Number"
                        disabled
                      />
                    </Form.Item>
                  </Col>
                  <Col xs={24} md={8} xl={8}>
                    <Form.Item
                      label="Phone Number"
                      name="phone_number"
                      rules={[
                        {
                          required: true,
                          message: 'Please enter Phone Number'
                        },
                        {
                          message: 'Phone number should be either 4 digits or 10 digits.',
                          pattern: PHONE_PATTERN
                        }
                      ]}
                    >
                      <Input type="tel" placeholder="Enter Phone Number" disabled />
                    </Form.Item>
                  </Col>
                  <Col xs={24} md={4} xl={4}></Col>
                </Row>
                <Row gutter={[16, 16]}>
                  <Col xs={24} md={4} xl={4}></Col>
                  <Col xs={24} md={8} xl={8}>
                    <Form.Item
                      label="Property ID"
                      name="property_id"
                      rules={[
                        {
                          required: true,
                          message: 'Please enter Property ID'
                        }
                      ]}
                    >
                      <Input placeholder="Enter Property ID" disabled />
                    </Form.Item>
                  </Col>
                  <Col xs={24} md={8} xl={8}>
                    <Form.Item
                      label="Execution Case Number"
                      name="execution_case_number"
                      rules={[
                        {
                          required: true,
                          message: 'Please enter Execution Case Number'
                        }
                      ]}
                    >
                      <Input placeholder="Execution Case Number" disabled />
                    </Form.Item>
                  </Col>
                  <Col xs={24} md={4} xl={4}></Col>
                </Row>

                <Row gutter={[16, 16]}>
                  <Col xs={24} md={4} xl={4}></Col>
                  <Col xs={24} md={8} xl={8}>
                    <Form.Item
                      label="Bid Reference Number"
                      name="transaction_reference"
                      rules={[
                        {
                          required: true,
                          message: 'Please enter transaction reference'
                        }
                      ]}
                    >
                      <Input placeholder="Bid Reference Number" disabled />
                    </Form.Item>
                  </Col>
                  <Col xs={24} md={8} xl={8}>
                    <Form.Item
                      label="Beneficiary Name"
                      name="beneficiary_bank_account_name"
                      rules={[
                        {
                          required: true,
                          message: 'Please enter Beneficial Name'
                        }
                      ]}
                    >
                      <Input placeholder="Beneficiary Account Name" disabled />
                    </Form.Item>
                  </Col>
                  <Col xs={24} md={4} xl={4}></Col>
                </Row>

                <Row gutter={[16, 16]}>
                  <Col xs={24} md={4} xl={4}></Col>
                  <Col xs={24} md={8} xl={8}>
                    <Form.Item
                      label="Deposit Bid Security Amount"
                      name="amount"
                      rules={[
                        {
                          required: true,
                          message: 'Please enter Amount'
                        }
                      ]}
                    >
                      <Input type="text" placeholder="Amount" disabled />
                    </Form.Item>
                  </Col>
                  <Col xs={24} md={8} xl={8}>
                    <Form.Item
                      label="Currency"
                      name="transaction_currency"
                      rules={[
                        {
                          required: true,
                          message: 'Please provide the transaction currency'
                        }
                      ]}
                    >
                      <Input maxLength={24} placeholder="RWF" disabled />
                    </Form.Item>
                  </Col>
                  <Col xs={24} md={4} xl={4}></Col>
                </Row>

                <Row gutter={[16, 16]}>
                  <Col xs={24} md={4} xl={4}></Col>
                  <Col xs={24} md={8} xl={8}>
                    <Form.Item
                      label="Bid Security Payment Date"
                      name="payment_date"
                      rules={[
                        {
                          required: true,
                          message: 'Payment Date not Available'
                        }
                      ]}
                    >
                      <Input placeholder="Bid Payment Date" disabled />
                    </Form.Item>
                  </Col>
                  <Col xs={24} md={8} xl={8}>
                    <Form.Item
                      label="Refundable Bid Security Amount"
                      name="refundable_bid_security_amount"
                      rules={[
                        {
                          required: true,
                          message: 'Refundable Bid Security Amount not Available'
                        }
                      ]}
                    >
                      <Input placeholder="Refundable Bid Security Amount" disabled />
                    </Form.Item>
                  </Col>
                </Row>

                <Row gutter={[16, 16]}>
                  <Col xs={24} md={4} xl={4}></Col>
                  <Col xs={24} md={8} xl={8}>
                    <Form.Item
                      label="Bank Account Number"
                      name="beneficiary_account_number"
                      rules={[
                        {
                          required: true,
                          message: 'Please enter Bank Account Number'
                        },
                        {
                          pattern: /^[0-9]+$/,
                          message: 'Please enter only numbers for Bank Account Number'
                        }
                      ]}
                    >
                      <Input
                        maxLength={24}
                        placeholder="Enter Bidder's Bank Account Number"
                      />
                    </Form.Item>
                  </Col>
                  <Col xs={24} md={8} xl={8}>
                    <Form.Item
                      label="Bank Name"
                      name="beneficiary_bank_name"
                      rules={[
                        {
                          required: true,
                          message: "Please enter Bidder's Bank Name"
                        }
                      ]}
                    >
                      <Input placeholder="Beneficiary Account Name" disabled />
                    </Form.Item>
                  </Col>
                </Row>

                <Row gutter={[16, 16]}>
                  <Col xs={24} md={4} xl={4}></Col>
                  <Col xs={24} md={8} xl={8}>
                    <Form.Item
                      label="Bank Account Name"
                      name="beneficiary_bank_account_name"
                      rules={[
                        {
                          required: true,
                          message: 'Please enter Bank Account Name'
                        }
                      ]}
                    >
                      <Input type="text" placeholder="Enter Bank Account Name" disabled />
                    </Form.Item>
                  </Col>
                  <Col xs={24} md={4} xl={4}>
                    <Col xs={24} md={8} xl={8}>
                      <Form.Item
                        label="Email"
                        name="email"
                        rules={[
                          {
                            required: true,
                            message: 'Please enter Email Address'
                          }
                        ]}
                        style={{ width: 420 }}
                      >
                        <Input type="text" placeholder="Enter Email Address" disabled />
                      </Form.Item>
                    </Col>
                    <Form.Item
                      // label="Bank Code"
                      name="bank_code"
                      hidden
                      rules={[
                        {
                          required: true,
                          message: 'Bank Code not Available'
                        }
                      ]}
                    >
                      <Input type="hidden" />
                    </Form.Item>
                  </Col>
                </Row>
                <Row gutter={[16, 16]}>
                  <Col xs={24} md={4} xl={4}></Col>
                  <Col xs={24} md={8} xl={8}>
                    <Form.Item
                      // label=" Bidder "
                      name="bidder_id"
                      hidden
                    >
                      <Input type="hidden" />
                    </Form.Item>
                  </Col>
                  <Col xs={24} md={8} xl={8}>
                    <Form.Item
                      // label="Bid security"
                      name="bid_security_id"
                      hidden
                    >
                      <Input type="hidden" />
                    </Form.Item>
                    {loadingRefund && <Spin size="large" />}
                  </Col>
                  <Col xs={24} md={4} xl={4}></Col>
                </Row>

                <Row gutter={[16, 16]}>
                  <Col xs={24} md={4} xl={4}></Col>
                  <Col xs={24} md={16} xl={16}>
                    <Form.Item name="declaration" rules={[{ required: false }]}>
                      <Checkbox
                        onChange={(e) => {
                          setDeclarationChecked(e.target.checked)
                        }}
                      >
                        I, <b>{fullName}</b>, hereby declare that the provided information about{' '}
                        <b>Account Number, Bank Account Name and Bank Name</b> are true, accurate
                        and complete.
                      </Checkbox>
                    </Form.Item>
                  </Col>
                  <Col xs={24} md={4} xl={4}></Col>
                </Row>

                <Row gutter={[16, 16]}>
                  <Col xs={24} md={4} xl={4}></Col>
                  <Col xs={24} md={16} xl={16}>
                    <Form.Item>
                      <Button
                        type="primary"
                        htmlType="submit"
                        disabled={loadingRefund || !declarationChecked}
                      >
                        {isEdit ? 'Update' : 'Continue'}
                      </Button>
                    </Form.Item>
                  </Col>

                  <Col xs={24} md={4} xl={4}></Col>
                </Row>
              </Card>
            </Space>
          </Form>
        )}
        <Row justify="center" align="middle" style={{ height: '100%' }}>
          <Col xs={24} md={24} xl={24}>
            {showSuccessAlert && (
              <Modal
                visible={showSuccessAlert}
                onCancel={() => {
                  setShowSuccessAlert(false)
                }}
                footer={null}
                centered
              >
                <Alert
                  message="Informational Notes"
                  /* eslint-disable-next-line @typescript-eslint/restrict-template-expressions */
                  description="Refund Request Submitted. Waiting to be Refunded..."
                  type="info"
                  showIcon
                  style={{
                    width: '100%'
                  }} // Set alert background color
                  onClose={() => {
                    setShowSuccessAlert(false)
                  }}
                />
              </Modal>
            )}
          </Col>
        </Row>
        <Row justify="center" align="middle" style={{ height: '100%' }}>
          <Col xs={24} md={24} xl={24}>
            {showWarningAlert && (
              <Modal
                visible={showWarningAlert}
                onCancel={() => {
                  setShowWarningAlert(false)
                }}
                footer={null}
                centered
              >
                <Alert
                  message="Informational Notes"
                  /* eslint-disable-next-line @typescript-eslint/restrict-template-expressions */
                  description={`Refund Request already exists with the same Transaction Reference Number: ${transactionReference}`}
                  type="info"
                  showIcon
                  style={{
                    width: '100%'
                  }} // Set alert background color
                  onClose={() => {
                    setShowWarningAlert(false)
                  }}
                />
              </Modal>
            )}
          </Col>
        </Row>
        <Row justify="center" align="middle" style={{ height: '100%' }}>
          <Col xs={24} md={24} xl={24}>
            {showWarningAlert2 && (
              <Modal
                visible={showWarningAlert2}
                onCancel={() => {
                  setShowWarningAlert2(false)
                }}
                footer={null}
                centered
              >
                <Alert
                  message="Informational Notes"
                  /* eslint-disable-next-line @typescript-eslint/restrict-template-expressions */
                  description={`Refund can only be triggered for payments starting from ${targetPaymentDateValue}. Any assistance, please contact us at iecms-support@minijust.gov.rw`}
                  type="error"
                  showIcon
                  style={{
                    width: '100%'
                  }} // Set alert background color
                  onClose={() => {
                    setShowWarningAlert2(false)
                  }}
                />
              </Modal>
            )}
          </Col>
        </Row>
        {/* Step 3: Render OTP form conditionally */}
        <Modal
          title={
            <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
              <span style={{ fontSize: '24px' }}>🔐</span>
              <span style={{ fontSize: '18px', fontWeight: '600' }}>Enter Verification Code</span>
            </div>
          }
          visible={showOTPForm && isFormSubmitted && isFormValidated && declarationChecked}
          onCancel={handleOTPFormCancel}
          footer={[
            <Button key="cancel" onClick={handleOTPFormCancel}>
              Cancel
            </Button>,
            <Button
              key="submit"
              type="primary"
              onClick={() => {
                // eslint-disable-next-line @typescript-eslint/no-confusing-void-expression
                void handleOTPSubmit()
              }}
              disabled={otpDigits.join('').length !== 6}
              loading={loadingRefund}
            >
              Verify & Submit
            </Button>
          ]}
          className="custom-modal"
          keyboard={false}
          maskClosable={false}
          width={500}
          style={{ borderRadius: '12px' }}
        >
          <div style={{ padding: '8px 0' }}>
            <div style={{ textAlign: 'center', marginBottom: '24px' }}>
              <p style={{ margin: '0 0 8px 0', color: '#666', fontSize: '14px' }}>
                We sent a verification code to your phone number ending with{' '}
                <strong style={{ color: '#1890ff' }}>
                  {phone_number.length > 2 ? `****${phone_number.slice(-2)}` : '******'}
                </strong>
              </p>
              <p style={{ margin: '0', color: '#999', fontSize: '12px' }}>
                Please enter the 6-digit code below
              </p>
            </div>

            {otpError !== '' && (
              <Alert
                message={otpError}
                type="error"
                showIcon
                style={{ marginBottom: '20px' }}
                closable
                onClose={() => { setOtpError('') }}
              />
            )}

            <Form.Item
              name="otp"
              rules={[{ required: true, message: 'Please enter the complete OTP code' }]}
              style={{ marginBottom: '20px' }}
            >
              <div style={{ display: 'flex', gap: '8px', justifyContent: 'center', marginBottom: '8px' }}>
                {otpDigits.map((digit, idx) => (
                  <Input
                    key={idx}
                    id={`otp-input-${idx}`}
                    value={digit}
                    inputMode="numeric"
                    pattern="[0-9]*"
                    maxLength={1}
                    onChange={(e) => { handleOtpChange(idx, e.target.value) }}
                    onKeyDown={(e) => { handleOtpKeyDown(idx, e) }}
                    onPaste={(e) => { handleOtpPaste(e) }}
                    style={{
                      width: '48px',
                      height: '56px',
                      textAlign: 'center',
                      fontSize: '24px',
                      fontWeight: '600',
                      borderRadius: '8px',
                      borderColor: (otpError !== '') ? '#ff4d4f' : '#d9d9d9',
                      borderWidth: '2px',
                      transition: 'all 0.2s'
                    }}
                    onFocus={(e) => {
                      e.target.style.borderColor = '#1890ff'
                      e.target.style.boxShadow = '0 0 0 2px rgba(24, 144, 255, 0.2)'
                    }}
                    onBlur={(e) => {
                      e.target.style.borderColor = (otpError !== '') ? '#ff4d4f' : '#d9d9d9'
                      e.target.style.boxShadow = 'none'
                    }}
                  />
                ))}
              </div>
            </Form.Item>

            <div style={{ textAlign: 'center', marginTop: '24px' }}>
              <p style={{ margin: '0 0 12px 0', color: '#666', fontSize: '13px' }}>
                Code expires in{' '}
                <code
                  style={{
                    fontSize: '16px',
                    fontWeight: 'bold',
                    color: countdown < 60000 ? '#ff4d4f' : '#1890ff',
                    background: '#f0f0f0',
                    padding: '4px 8px',
                    borderRadius: '4px'
                  }}
                >
                  {moment(countdown).format('mm:ss')}
                </code>
              </p>
              <div style={{ marginTop: '16px' }}>
                {countdown === 0
                  ? (
                      <Button
                        type="link"
                        onClick={() => { void handleResendOTP() }}
                        style={{ padding: '0', fontWeight: '600' }}
                      >
                        Resend Code
                      </Button>
                    )
                  : (
                      <p style={{ margin: '0', color: '#999', fontSize: '12px' }}>
                        Didn&apos;t receive the code?{' '}
                        <Button
                          type="link"
                          disabled
                          style={{ padding: '0', fontSize: '12px' }}
                        >
                          Resend in {moment(countdown).format('mm:ss')}
                        </Button>
                      </p>
                    )}
              </div>
            </div>

            <div
              style={{
                marginTop: '20px',
                padding: '12px',
                background: '#f0f9ff',
                borderRadius: '8px',
                border: '1px solid #bae7ff'
              }}
            >
              <p style={{ margin: '0', fontSize: '12px', color: '#666', lineHeight: '1.5' }}>
                <strong>💡 Tip:</strong> You can paste the entire 6-digit code at once, or enter each digit
                individually.
              </p>
            </div>
          </div>
        </Modal>

        <Modal
          title="Notification"
          visible={showBankCodeModal}
          onCancel={() => {
            setShowBankCodeModal(false)
            setShowCancelMessage(true)
          }}
          footer={null}
          centered
        >
          {isVisible && (
            <>
              <p style={{ fontWeight: 'bold', color: '#333' }}>Please wait while fetching...</p>
              <hr style={{ borderTop: '2px solid #ccc', margin: '10px 0' }} />
              <p style={{ fontWeight: 'bold', fontSize: 'var(--base-font-size)', color: '#333' }}>
                Mutegereze gato mu gihe turi kureba amakuru ajyanjye ni ingwate ya cyamunara muri
                gusaba...
              </p>
            </>
          )}
          {showHello && <p>The bank details are missing. You are not eligible to be refunded.</p>}
        </Modal>
        <Modal
          title="Notification"
          visible={showInvalidReferenceNumberModal}
          onCancel={() => {
            setShowInvalidReferenceNumberModal(false)
            setShowCancelMessage(true)
          }}
          footer={null}
          centered
        >
          {isVisible && (
            <p>
              <strong>Please wait while fetching...</strong>
            </p>
          )}
          {showHello && <p>Invalid Reference Number. You are not eligible to be refunded.</p>}
        </Modal>
        <Modal
          title="Validation Error"
          visible={showValidationErrorModal}
          onCancel={() => {
            setShowValidationErrorModal(false)
            setValidationErrorMessage('')
          }}
          footer={[
            <Button
              key="ok"
              type="primary"
              onClick={() => {
                setShowValidationErrorModal(false)
                setValidationErrorMessage('')
              }}
            >
              OK
            </Button>
          ]}
          centered
        >
          <Alert
            message="Validation Failed"
            description={validationErrorMessage}
            type="error"
            showIcon
            style={{ marginBottom: '16px' }}
          />
          <p style={{ margin: 0, color: '#666' }}>
            Please check your transaction reference and try again. If the problem persists, contact support at{' '}
            <strong>iecms-support@minijust.gov.rw</strong>
          </p>
        </Modal>
        <Modal
          title={(fetchedBankCode === '040' || fetchedBankCode === '40') ? 'Bid Security Refund Amount' : 'Bank Transfer Charges'}
          visible={
            showBankTransferChargeModal &&
            fetchedBankCode !== null &&
            form.getFieldValue('beneficiary_bank_account_name') !== null
          }
          onCancel={() => {
            setShowBankTransferChargeModal(false)
            setShowCancelMessage(true)
          }}
          footer={[
            <Button
              key="cancel"
              onClick={() => {
                setShowBankTransferChargeModal(false)
                setShowCancelMessage(true)
              }}
            >
              Cancel
            </Button>,
            <Button type="primary" key="ok" onClick={handleAgree}>
              I Agree
            </Button>
          ]}
          keyboard={false}
          maskClosable={false}
          className="custom-modal"
        >
          <p>
            {/* eslint-disable-next-line max-len */}
            You will be charged{' '}
            <strong>
              {(fetchedBankCode !== '040' && fetchedBankCode !== '40') ? '1,000 Rwf (BK to other Banks).' : '0 Rwf (BK to BK)'}
            </strong>
            .
          </p>
          <p>
            Total bid Security Paid:{' '}
            <strong>{parseInt(String(paymentAmount)).toLocaleString()} Rwf </strong>
          </p>
          {fullName != null && (
            <p>
              Amount Received in Your Account after Transfer:{' '}
              <strong>
                {parseInt(
                  String(Number(paymentAmount) - ((fetchedBankCode !== '040' && fetchedBankCode !== '40') ? 1000 : 0))
                ).toLocaleString()}{' '}
                Rwf
              </strong>
            </p>
          )}
        </Modal>

        {showCancelMessage && (
          <div className="cancel-message">
            <div className="separator"></div>
            <p>
              <h3>Thank you for using our services.</h3>
            </p>
            <div className="separator"></div>
            <p>
              For any other support, please contact us on
              <span>
                <strong> iecms-support@minijust.gov.rw</strong>
              </span>
              .
            </p>
          </div>
        )}
      </div>
    </div>
  )
}

export default MakeRefundRequest
